import { createSelector } from "reselect"
import { find, map, get } from "lodash"
import { getSelectedDate } from "modules/security-profile/selectors/dates"
import { getFilteredData, getCategoryItems, getSingleItemCategories } from "./data"

export const getDetails = createSelector(
  [getFilteredData, getCategoryItems, getSingleItemCategories, getSelectedDate],
  (data, items, singleItemCategories, date) => {
    const datum = find(data, d => d.date.isSame(date))

    return map(items, item => ({
      ...item,
      value: get(datum, item.id),
      secondaryLabel: item.type === "category" ? singleItemCategories[item.id] : undefined,
    }))
  },
)
